import React from 'react';
import './firework.css';
const Firework = () => {
   return <div class="firework"></div>;
};

export default Firework;
